module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-taglist', {
    attrs: {
      "attached": ""
    }
  }, [_c('b-tag', {
    attrs: {
      "type": "is-dark"
    }
  }, [_vm._v("npm")]), _vm._v(" "), _c('b-tag', {
    attrs: {
      "type": "is-info"
    }
  }, [_vm._v("0.5.1")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ee707ca"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/tag/examples/ExTaglistAttached.vue
// module id = 1247
// module chunks = 16 178